<template>
  <div class="bg-F6F6F6 leave-records-list">
    <ul>
      <li
        v-for="item in list"
        :key="item.leaveId"
        class="fb fb-col bg-FFFFFF mb-12"
      >
        <md-list class="" @click="handlerClickItem(item)" arrow>
          <md-list-item
            :title="item.personName"
            @click="handlerClickItem(item)"
          >
            <common-leave-status
              slot="description"
              class="font-30"
              :status="item.approveStatus"
            ></common-leave-status>
          </md-list-item>
        </md-list>
        <div
          class="font-28 p-0-16 c-171A1D-60 mb-16"
          @click="handlerClickItem(item)"
        >
          <p>
            <span>请假类型：</span>
            <span
              >{{ item.leaveTypeName }}
              <template v-if="item.fever"> (发热) </template>
            </span>
          </p>
          <p>
            <span>开始时间：</span>
            <span
              class="leave-time font-32"
              v-if="+item.leaveDurationUnit === 2"
              >{{ item.localStartTime }}</span
            >
            <common-time
              v-else
              class="leave-time font-32"
              :time="item.startTime"
              format="YYYY-MM-DD hh:mm"
            ></common-time>
          </p>
          <p>
            <span>结束时间：</span>
            <span
              class="leave-time font-32"
              v-if="+item.leaveDurationUnit === 2"
              >{{ item.localEndTime }}</span
            >
            <common-time
              v-else
              class="leave-time font-32"
              :time="item.endTime"
              format="YYYY-MM-DD hh:mm"
            ></common-time>
          </p>
        </div>
        <md-list
          v-if="
            type !== 2 &&
            (allowLeaveBackCertificate
              ? item.backSchoolStatus > 0
              : item.backSchoolStatus > 1)
          "
          class="bt"
          arrow
        >
          <md-list-item
            title="返校证明"
            @click="
              handlerClickList(
                item.backSchoolStatus,
                item.dingPersonId,
                item.leaveId
              )
            "
          >
            <span
              class="font-30"
              slot="description"
              :style="{
                color: BACK_SCHOOL_STATUS[+item.backSchoolStatus].color
              }"
              >{{ BACK_SCHOOL_STATUS[+item.backSchoolStatus].content }}</span
            >
          </md-list-item>
        </md-list>
      </li>
    </ul>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonLeaveStatus from './commonLeaveStatus'
import commonTime from './commonTime'

import { BACK_SCHOOL_STATUS } from '@/utils/constUtils'

export default {
  mixins: [mixin],
  name: 'commonLeaveList',
  components: { commonLeaveStatus, commonTime },
  props: {
    list: Array,
    // 2: 修改或撤销请假列表
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      UNIT_TYPE: ['', 'startTime', 'localStartTime'],
      BACK_SCHOOL_STATUS
    }
  },
  computed: {
    computedIsLongLeave() {
      return item => {
        let _isLong = false
        let _startTime = new Date(
          Math.floor(item.startTime / 1000 / 60 / 60) * 60 * 60 * 1000
        )
        let _endTime = new Date(
          Math.floor(item.endTime / 1000 / 60 / 60) * 60 * 60 * 1000
        )
        _startTime.setHours(0)
        _endTime.setHours(0)

        if (_endTime.getTime() > _startTime.getTime()) {
          _isLong = true
        }

        return _isLong
      }
    },
    allowLeaveBackCertificate() {
      return this.$store.getters.allowLeaveBackCertificate
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  async mounted() {
    await this.$store.dispatch('leaveBackConfigGet', {})
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerClickItem(item) {
      this.$emit('click', item)
    },
    handlerClickList(backSchoolStatus, studentDingIds, leaveId) {
      let url = '/leave/backdetail'
      //  返校证明状态 1：未上传 2：待审核 3：已通过 4：已拒绝 5: 已失效
      if (this.allowLeaveBackCertificate) {
        const _goBack =
          (this.curIsGuardian || this.isStudent) && backSchoolStatus === 1
        _goBack && (url = '/leave/back')
      }
      this.$emit('clickBack', url, studentDingIds, leaveId)
    }
  }
}
</script>

<style lang="scss" scoped>
.leave-records-list {
  width: 100%;
}
</style>
